/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createHttpValidationProblemDetailsFromDiscriminatorValue, createIErrorFromDiscriminatorValue, createPaymentMethodResponseFromDiscriminatorValue, type HttpValidationProblemDetails, type IError, type PaymentMethodResponse } from '../../models/index.js';
// @ts-ignore
import { DefaultRequestBuilderRequestsMetadata, type DefaultRequestBuilder } from './defaultEscaped/index.js';
// @ts-ignore
import { SetupIntentRequestBuilderRequestsMetadata, type SetupIntentRequestBuilder } from './setupIntent/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /billing/payment-methods
 */
export interface PaymentMethodsRequestBuilder extends BaseRequestBuilder<PaymentMethodsRequestBuilder> {
    /**
     * The default property
     */
    get defaultEscaped(): DefaultRequestBuilder;
    /**
     * The setupIntent property
     */
    get setupIntent(): SetupIntentRequestBuilder;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PaymentMethodResponse[]>}
     * @throws {HttpValidationProblemDetails} error when the service returns a 400 status code
     * @throws {IError} error when the service returns a 404 status code
     * @throws {IError} error when the service returns a 409 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<PaymentMethodResponse[] | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const PaymentMethodsRequestBuilderUriTemplate = "{+baseurl}/billing/payment-methods";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const PaymentMethodsRequestBuilderNavigationMetadata: Record<Exclude<keyof PaymentMethodsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    defaultEscaped: {
        requestsMetadata: DefaultRequestBuilderRequestsMetadata,
    },
    setupIntent: {
        requestsMetadata: SetupIntentRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const PaymentMethodsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: PaymentMethodsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createHttpValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
            409: createIErrorFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "sendCollection",
        responseBodyFactory:  createPaymentMethodResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
